import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class CreateMagiisAccessUserProfileMagiisUserId extends IRequestCommand<
  ICreateMagiisAccessUserProfileMagiisUserIdResponse,
  ErrorDetails,
  ICreateMagiisAccessUserProfileMagiisUserIdParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.POST;

  override setParameters(parameters: ICreateMagiisAccessUserProfileMagiisUserIdParameters) {
    this._commandBody = parameters.carrierProfileIds.map((id)=>Number(id)) as any;
    this.urlSections.push('magiisaccess');
    this.urlSections.push(`userprofile`);
    this.urlSections.push(`magiisuserid`);
    this.urlSections.push(`${parameters.magiisUserId}`);
    this.composeUrl();
  }
}

export interface ICreateMagiisAccessUserProfileMagiisUserIdParameters extends ICommandParameters{
  magiisUserId: number;
  carrierProfileIds: (string|number)[];
}

export interface ICreateMagiisAccessUserProfileMagiisUserIdResponse extends ICommandResponse{

}
